module.exports = __webpack_public_path__ + "static/media/6D.a8aabd2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/6D.svg
// module id = 70
// module chunks = 0